import React from 'react';
import { motion } from 'framer-motion';


const OtherExpertLedSolutionsSection = ({title, description, solutionsData}) => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white font-sans text-left">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="mb-[32px] md:mb-[60px] max-w-[609px]"
                >
                    <h2 className="text-[20px] md:text-[30px] font-sora font-[600] text-[#01386A] tracking-tight mb-[12px] md:mb-[16px]">
                        {title}
                    </h2>
                    <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] font-graphik leading-[1.6]">
                     {description}
                    </p>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[16px] md:gap-[24px]"
                >
                    {solutionsData.map((item) => (
                        <motion.div
                            key={item.id}
                            variants={fadeUpVariant}
                            className="group relative w-full h-[320px] sm:h-[360px] lg:h-[420px] overflow-hidden cursor-pointer"
                        >
                            <img
                                src={item.image}
                                alt={item.title}
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-transparent"></div>

                            <div className="absolute bottom-0 left-0 p-[20px] sm:p-[24px] md:p-[28px] w-full flex flex-col justify-end">
                                <h3 className="text-white text-[16px] md:text-[20px] font-sora font-[600]">
                                    {item.title}
                                </h3>
                                <div className="grid grid-rows-[1fr] md:grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out group-hover:md:grid-rows-[1fr]">
                                    <div className="overflow-hidden">
                                        <p className="text-white/90 text-[13px] md:text-[15px] font-graphik leading-[1.5] md:leading-[1.6] font-medium pt-[8px] md:pt-[12px] opacity-100 md:opacity-0 transition-opacity duration-500 delay-100 group-hover:md:opacity-100">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default OtherExpertLedSolutionsSection;